import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./Navbar"; // Import your Navbar component
import Footer from "./Footer"; // Import your Footer component

// Import pages
import HomePage from "./pages/HomePage";
import ContactPage from "./pages/ContactPage";
import ProjectPage from "./pages/ProjectPage"
import ResumePage from "./pages/ResumePage"
import ProjectDetail from "./pages/ProjectDetail"
import Layout from "./Layout";

function App() {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem("theme");

    if (savedTheme) {
      return savedTheme === "dark";
    }

    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });

  useEffect(() => {
    const root = document.documentElement;

    if (isDarkMode) {
      root.classList.add("dark");
      localStorage.setItem("theme", "dark");
      return;
    }

    root.classList.remove("dark");
    localStorage.setItem("theme", "light");
  }, [isDarkMode]);

  const toggleTheme = () => setIsDarkMode((prevMode) => !prevMode);

  return (
    <Router>
      <Navbar isDarkMode={isDarkMode} onToggleTheme={toggleTheme} /> {/* Navbar stays on top */}
      <Layout>
        <Routes>
        <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/projects" element={<ProjectPage />} />
          <Route path="/projects/:id" element={<ProjectDetail />} />
          <Route path="/resume" element={<ResumePage />} />
        </Routes>
        </Layout>
      <Footer /> {/* Footer stays at the bottom */}
    </Router>
  );
}

export default App;
